import React from 'react';
import PropTypes from 'prop-types';
import className from 'classnames';

class ImageLoader extends React.Component {
  static propTypes = {
    url: PropTypes.string,
    openable: PropTypes.bool,
  };

  static defaultProps = {
    klassName: null,
    renderAsImg: false,
    wrapped: true,
    openable: true,
  };

  state = {
    isMounted: false,
    needsPlaceholder: false,
  };

  componentDidMount = () => {
    this._load()
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.url != prevProps.url) {
      this._load()
    }
  }

  _load = () => {
    if (this.props.url) {
      setTimeout(() => {
        this._loadImage(this.props);
      }, 100)
    }
  }

  _loadImage = (props) => {
    const _img = new Image();
    _img.src = props.url;

    // Image passed as props may be changed from undefined, so at first try
    // it might be error. We need to give it another shot once prop changes.
    _img.onload = () => {
      this.setState(() => ({
        needsPlaceholder: false,
      }));
    };

    _img.onerror = () => {
      this.setState(() => ({
        needsPlaceholder: true,
      }));
    };
  }

  render() {
    const _needsPlaceholder = this.state.needsPlaceholder || !this.props.url
    let $el

    if (this.props.renderAsImg && !_needsPlaceholder) {
      $el = (
        <img
          className={className('ImageLoader', {
            [this.props.klassName]: this.props.klassName,
          })}
          src={this.props.url}
          data-url={this.props.url}
          style={{
            ...this.props.style,
          }}
        />
      )
    }
    else {
      $el = (
        <figure
          className={className('ImageLoader', {
            'ImageLoader--placeholder': _needsPlaceholder,
            [this.props.klassName]: this.props.klassName,
          })}
          style={{
            ...this.props.style,
            backgroundImage: _needsPlaceholder ? 'none' : `url(${this.props.url})`
          }}
          data-url={this.props.url}
        />
      );
    }

    if (!this.props.wrapped) {
      return $el
    }

    const Renderer = this.props.openable ? 'a' : 'div'

    return (
      <Renderer
        href={this.props.url}
        target='_blank'
        className='ImageLoader__wrapper'
      >
        {$el}
      </Renderer>
    )
  }
}

export default ImageLoader;
